import {useState,useEffect,useRef} from "react";
import dropDownLogo from "../../assets/images/downArrow.svg";
import uplLogo from "../../assets/images/UPL_Genie_logo 1.svg";
import faqIcon from "../../assets/images/faqIcon.svg";
import feedbackIcon from "../../assets/images/review 1.svg";
import setting from "../../assets/images/settings.svg";
import feedbackMobile from "../../assets/images/feedbackMobile.svg"
import policyIcon from "../../assets/images/policy-24.png";
import settingMobile from "../../assets/images/settingsMobile.svg"
import logoutMobile from "../../assets/images/logoutMobile.svg"
import aboutIcon from "../../assets/images/icons8-info.svg";
import LogoutModal from "../Logout/Logout";
import newChat from "../../assets/images/newchat.svg"
import Threads from "../Thread/Thread";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useEventEmitter } from "../../contexts/EventEmmiter";
import './Header.css';
import menuIcon from "../../assets/images/menuIcon.svg"
import Policy from "../Policy/Policy";
import { useDispatch, useSelector } from "react-redux";
import { fetchModelDetails, postPolicySign } from "../../store/apiActions";
import { env } from "../../environment";
import policyPDF from "../../assets/logos/UPL AI Acceptable Usage Policy.pdf";
import aboutPDF from "../../assets/logos/UPLGenie-Model Guide - edited.pdf";

const getUsername = () => {
    const storedData = localStorage.getItem("LoggedInDetails");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      return parsedData.username;
    }
    return null;
  };
const Header = ({
  selectedModel,
//   isUserMenuOpen,
  fullname,
  handleModelChange,
  handleFaqNavigation,
  handleOpenForm,
  isUpdateThread,
}) => {
    const [model, setModel] = useState([]);
    const [isPolicyFirst, setIsPolicyFirst] = useState(false);
    const [modelTitle, setModelTitle] = useState("AI Usage Policy");
    const { subscribe, emit } = useEventEmitter();
    const [openPDF, setOpenPDF] = useState(false);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const username = getUsername();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const sidebarRef = useRef();
      const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () =>{
     setIsSidebarOpen(prev => !prev)
    };
    const dropdownRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isOpen, setIsOpen] = useState(false);
    const [showLogoutModal, setShowModal] = useState(false);

     useEffect(() => {
    const handleClickOutside = (event) => {
      if (isSidebarOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        const confirmModalElement = document.querySelector('.modal-overlay'); 
        if (confirmModalElement && confirmModalElement.contains(event.target)) {
            return;
        }
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen]);
  useEffect(() => {
        const unsubscribe = subscribe("closeSidebar", () => {
            setIsSidebarOpen(false);
        });

        return () => unsubscribe();
    }, [subscribe]);

    const modelResponse = useSelector(
        (state) => state?.api?.modelDetails || []
      );
    const handleOpenModal = (data) => {
        setOpenPDF(true);
        setIsSidebarOpen(false);
        setIsUserMenuOpen(false);
        setIsPolicyFirst(false);
        if (data == "AI Usage Policy") {
          setModelTitle("AI Usage Policy");
        } else {
          setModelTitle("Model Selection Guide");
        }
      };

      const handleToggle = () => {
        setIsOpen(!isOpen);
      };
        useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
      
      useEffect(() => {
        dispatch(fetchModelDetails(`${env.baseURL}/models/base`));
      }, [dispatch]);
    
      useEffect(() => {
        if(modelResponse?.error?.response?.status=='401'){
          toast.error("Session expired. Please login again.");
          localStorage.clear();
          setTimeout(() => {
            navigate("/sign-in");
          }, 1500);
          return;
        }
        setModel(modelResponse?.data?.data);
      }, [modelResponse]);

      useEffect(() => {
        const data = localStorage.getItem("isPolicy");
        if (data === "false") {
          setOpenPDF(true);
          setIsPolicyFirst(true);
        } else {
          setOpenPDF(false);
          setIsPolicyFirst(false);
        }
      }, []);

      const handlePostPolicySign = () => {
        setOpenPDF(false);
        const data = localStorage.getItem("isPolicy");
        if (data === "false") {
          setIsPolicyFirst(true);
          localStorage.setItem("isPolicy", true);
          dispatch(
            postPolicySign(`${env.baseURL}/accept-policy`, {
              ugdn_id: username,
            })
          );
        }
      };
      function handleConfirmNewChat() {
        emit("newChat", true);
      }
      const handleLogout = async () => {
          try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${env.baseURL}/app-users/logout`, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });
            if (response.ok) {
              toast.success("Logout successful!");
              localStorage.clear();
              setShowModal(false);
              localStorage.setItem('logout',true)
              navigate("/sign-in");
            } else {
              toast.success("Logout successful!");
              localStorage.clear();
              setShowModal(false);
              localStorage.setItem('logout',true)
              navigate("/sign-in");
            }
          } catch (error) {
            toast.success("Logout successful!");
          }
        };
      

      useEffect(() => {
        const handleClickOutside = (event) => {
          if (
            !event.target.closest(".user-dropdown") &&
            !event.target.closest(".icon-button")
          ) {
            setIsUserMenuOpen(false);
          }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);
      
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);
      return (
        <div className={`main-container ${isMobile ? "" : "desktop"}`}>
          {!isMobile && (
        <div className="chatbot-logo">
        <div
          style={{
            paddingLeft: "3%",
            display: "flex",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          <img height={"70%"} width={"70%"} src={uplLogo} alt="upl-logo" />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          {/* Model Dropdown */}
          <div className="model-selector" ref={dropdownRef}>
            <div className="select-dropdown" onClick={handleToggle}>
              <span className="selector-text">
                {selectedModel || "No Model Available"}
              </span>
              <img
                src={dropDownLogo}
                alt="Dropdown Icon"
                className={`selector-arrow ${isOpen ? "rotate" : ""}`}
              />
              {isOpen && (
                <div className="selector-menu">
                  {model.map((item) => (
                    <div
                      key={item.id}
                      className={`selector-item ${
                        selectedModel === item.name ? "active" : ""
                      }`}
                      onClick={() => handleModelChange(item.name)}
                    >
                      <label htmlFor={`radio-${item.name}`} className="radio-label">
                        <input
                          type="radio"
                          id={`radio-${item.name}`}
                          name="label"
                          value={item.name}
                          checked={selectedModel === item.name}
                          onChange={handleModelChange}
                        />
                        {item.name}
                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Profile section */}
          <div className="profile-container-header">
            <div onClick={handleFaqNavigation} className="feedback-header-container">
              <img src={faqIcon} alt="FAQ" />
              <span>User Guide</span>
            </div>
            <div onClick={handleOpenForm} className="feedback-header-container">
              <img src={feedbackIcon} alt="Feedback" />
              <span>Feedback</span>
            </div>
            <div className="first-Character">{fullname?.charAt(0)}</div>
            <div className="profile-fullname-container">{fullname}</div>
            <div
              className="setting-container"
              onClick={() => setIsUserMenuOpen((prev) => !prev)}
            >
              <img src={setting} alt="settings" />
            </div>
          </div>

          {/* User dropdown */}
          {isUserMenuOpen && (
            <div className="user-dropdown">
              <div className="dropdown-item-settings" onClick={() => handleOpenModal("About")}>
                <span className="dropdown-icon">
                  <img src={aboutIcon} alt="" />
                </span>
                Model Selection Guide
              </div>
              <div
                className="dropdown-item-settings"
                onClick={() => handleOpenModal("AI Usage Policy")}
              >
                <span className="dropdown-icon">
                  <img src={policyIcon} alt="" />
                </span>
                AI Usage Policy
              </div>
            </div>
          )}
        </div>
        
      </div>
    )}
    {isMobile && (
       <div className="mobile-navbar" ref={sidebarRef}>
          <div className="mobile-left">
               <button className="hamburger-button" onClick={toggleSidebar}>
              <img src={menuIcon} alt="hamburger-icon" /></button>
          </div>
          <div className="mobile-right">
             <div onClick={handleFaqNavigation} className="feedback-header-container">
              <img src={faqIcon} alt="FAQ" />
              <span>User Guide</span>
            </div>
             {(location?.pathname==="/chat" &&
              <div className="add-new-chat">
                <button
                  onClick={handleConfirmNewChat}
                  className="new-chat-button">
                  <img src={newChat} alt="Add New" />
                </button>
              </div>
            )}
      <div className="model-selector" ref={dropdownRef}>
        <div className="select-dropdown" onClick={handleToggle}>
          <span className="selector-text">
            {selectedModel || "No Model Available"}
          </span>
          <img
            src={dropDownLogo}
            alt="Dropdown Icon"
            className={`selector-arrow ${isOpen ? "rotate" : ""}`}
          />
          {isOpen && (
            <div className="selector-menu">
              {model.map((item) => (
                <div
                  key={item.id}
                  className={`selector-item ${
                    selectedModel === item.name ? "active" : ""
                  }`}
                  onClick={() => handleModelChange(item.name)}
                >
                  <label htmlFor={`radio-${item.name}`} className="radio-label">
                    <input
                      type="radio"
                      id={`radio-${item.name}`}
                      name="label"
                      value={item.name}
                      checked={selectedModel === item.name}
                      onChange={handleModelChange}
                    />
                    {item.name}
                  </label>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
       </div>
       </div>
      )}
      {isSidebarOpen && isMobile && (
        <div className="mobile-sidebar" ref={sidebarRef}>
          {/* User Info */}
          <div className="sidebar-profile">
            <div className="first-Character">{fullname?.charAt(0)}</div>
            <div className="profile-fullname-container">{fullname}</div>
            <div>
            </div>
          </div>
          <div className="sidebar-section">
            <Threads
              isUpdateThread={isUpdateThread}
            />
          </div>
           
          <div className="sidebar-footer">
            <div className="sidebar-footer-actions">
              <div
                className="sidebar-item"
                onClick={() => setIsUserMenuOpen((prev) => !prev)}
              >
                
                <img src={settingMobile} alt="settings" />
                Settings
              </div>
              
              <div className="sidebar-item" onClick={() => {
                handleOpenForm();
                setIsSidebarOpen(false);
              }}>
                <img src={feedbackMobile} alt="Feedback" />
                Feedback
              </div>
              <div className="sidebar-item" onClick={() => {
                setShowModal(true);
                setIsSidebarOpen(false);
              }}>
                <img src={logoutMobile} alt="Feedback" />
                Logout
              </div>
            </div>
             {isUserMenuOpen && (
                <div className="user-dropdown">
                  <div
                    className="dropdown-item-settings"
                    onClick={() => handleOpenModal("About")}
                  >
                    <span className="dropdown-icon">
                      <img src={aboutIcon} alt="" />
                    </span>
                    Model Selection Guide
                  </div>
                  <div
                    className="dropdown-item-settings"
                    onClick={() => handleOpenModal("AI Usage Policy")}
                  >
                    <span className="dropdown-icon">
                      <img src={policyIcon} alt="" />
                    </span>
                    AI Usage Policy
                  </div>
                </div>
              )}
          </div>
        </div>
      )}
    <LogoutModal
          show={showLogoutModal}
          handleLogout={handleLogout}
         handleClose={() => setShowModal(false)}
    />
    <Policy
      open={openPDF}
      onClose={() => setOpenPDF(true)}
      handleOnclickSubmit={handlePostPolicySign}
      pdfFile={modelTitle === "AI Usage Policy" ? policyPDF : aboutPDF}
      isPolicyFirst={isPolicyFirst}
      heading={modelTitle}
      buttonTitle="Accept & Continue"
    />
  </div>
);
}
export default Header;
